"use strict";
/*
 * Created on Tue Aug 07 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var RangeConstraintBuilder_1 = require("./RangeConstraintBuilder");

var RangeConstraintConverter_1 = require("./RangeConstraintConverter");

var RangeConverter_1 = require("./RangeConverter");
/**
 * Default implementation of {@link RangeConstraintConverterImpl}.
 *
 * @author RV
 */


var RangeConstraintConverterImpl =
/*#__PURE__*/
function (_RangeConstraintConve) {
  _inherits(RangeConstraintConverterImpl, _RangeConstraintConve);

  function RangeConstraintConverterImpl(rangeConverter) {
    var _this;

    _classCallCheck(this, RangeConstraintConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeConstraintConverterImpl).call(this));
    _this.rangeConverter = rangeConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RangeConstraintConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new RangeConstraintBuilder_1.RangeConstraintBuilder(this.deserializeConstraintType(source, conversions), this.rangeConverter.toObject(source.range, conversions)).build();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        constraintType: source.getType(),
        range: conversions.asObject(source, 'range', function (range) {
          return _this2.rangeConverter.toDocument(source.range, conversions);
        })
      });
      return result;
    }
  }]);

  return RangeConstraintConverterImpl;
}(RangeConstraintConverter_1.RangeConstraintConverter);

RangeConstraintConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [RangeConverter_1.RangeConverter])], RangeConstraintConverterImpl);
exports.RangeConstraintConverterImpl = RangeConstraintConverterImpl;